{
  "endTime": "שעת סיום",
  "startTime": "שעת התחלה",
  "time": "זמן"
}
